import { Component, inject } from '@angular/core';
import {IconComponent} from '../../../icons/icon.component';
import {MainNavigationService} from '../main-navigation.service';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'app-main-navigation-trigger',
  imports: [
    IconComponent,
    AsyncPipe
  ],
  templateUrl: './main-navigation-trigger.component.html',
  styleUrl: './main-navigation-trigger.component.scss'
})
export class MainNavigationTriggerComponent {
  private _mainNavigationService = inject(MainNavigationService);


  menuOpen$ = this._mainNavigationService.menuOpen$

  onToggleMenu() {
    this._mainNavigationService.toggleMenu()
  }
}
